import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';

import type { AxiosError } from 'axios';
import type { UseMutationOptions } from '@tanstack/react-query';
import type { PostRecentRegionParams, Region } from '../constants/types';

type PostRecentRegionOptions = UseMutationOptions<Region[], AxiosError, PostRecentRegionParams>;

/**
 * 현재 사용자가 최근 사용 리전을 업데이트하는 훅입니다.
 * @description
 * - react-query로 mutate를 제공합니다.
 */
const usePostRecentRegion = (options?: PostRecentRegionOptions) => {
  const client = useQueryClient();
  const { postRecentRegion } = useMetaApiInstance();

  const mutation = async (param: PostRecentRegionParams) => {
    const response = await postRecentRegion(param);
    return response;
  };

  return useMutation({
    mutationKey: [HOST_QUERY_KEY.UPDATE_RECENT_REGION],
    mutationFn: mutation,
    onSuccess: res => {
      client.setQueryData<Region[]>([HOST_QUERY_KEY.GET_RECENT_REGION], res);
    },
    ...options,
  });
};

export default usePostRecentRegion;
